import { Box, HStack } from 'native-base';
import { useTranslation } from 'react-i18next';

import { ChartStatisticsDto } from '@pimm/services/lib/store-equipment';
import { Text } from '@pimm/base';
import { buildChartStatTiles } from '../_helper';

type ChartStatisticsProps = { statistics?: ChartStatisticsDto; realTimeStatistics?: ChartStatisticsDto };

export const ChartStatistics = ({ statistics, realTimeStatistics }: ChartStatisticsProps) => {
  const { t } = useTranslation();
  return (
    <Box flexDirection="row" flexWrap="wrap" alignItems="baseline" style={{ columnGap: 10 }}>
      {buildChartStatTiles(statistics, realTimeStatistics).map((stat, index) => (
        <HStack key={index} alignItems="baseline" space={1.5}>
          <Text
            size="sm"
            color="gray.500"
            fontWeight={600}
            textTransform="uppercase"
            letterSpacing={0.5}
            numberOfLines={1}
            allowFontScaling
          >
            {t(stat.title)}
            {'  '}
            <Text size="sm" color="black" fontWeight={700}>
              {stat.value}
            </Text>
          </Text>
        </HStack>
      ))}
    </Box>
  );
};
